import uploadshomesidebysideimagethreePeopleWalkingJpg from "$lib/data/generated/uploads/home/SideBySide/image/Three People Walking.jpg";

export const uploads = {
  "uploads/home/SideBySide/image/Three People Walking.jpg": uploadshomesidebysideimagethreePeopleWalkingJpg
};